import queryString from 'query-string';
import { baseURL } from "./request";

/**
 *
 * @param {number} certificateId
 * @param {('en'|'de')} version
 */
export function createCertificateFileUrl(certificateId, version) {
  return `${baseURL}/certificate/${certificateId}/${version}`;
}

/**
 *
 * @param {number} testReportId
 */
export function createTestReportLink(testReportId) {
  return `${baseURL}/report/${testReportId}`
}

/**
 *
 * @param {number} companyId
 * @param {number} testReportId
 * @param {('en'|'de')} version
 */
export function createTestReportCertificateLink(companyId, testReportId, version) {
  return `${baseURL}/company/${companyId}/report/${testReportId}/${version}`
}

/**
 *
 * @param {number} testPlanId
 */
export function createTestPlanFileUrl(testPlanId) {
  return `${baseURL}/test-plan/${testPlanId}`;
}

/**
 *
 * @param {number | undefined} companyId
 */
export function createCompanyLogoUrl(companyId) {
  return companyId ? `${baseURL}/logo/${companyId}` : ''
}

/**
 *
 * @param {number | undefined} companyId
 * @param {boolean} isArchive
 */
export function createAllCertificateLink(companyId, isArchive = false) {
  return companyId ? `${baseURL}/certificate/${companyId}${isArchive ? '/archive' : '/actual'}` : ''
}

/**
 *
 *  @param {number | undefined} companyId
 *  @param {boolean} isArchive
 */
export function createAllReportLink(companyId, isArchive = false) {
  return companyId ? `${baseURL}/report/${companyId}/company${isArchive ? '/archive' : '/actual'}` : ''
}

export function createWPFileLink(name) {
  return `${baseURL}/whitepaper/${name}`
}

export const getQueryObject = (query = window.location.search) => {
  return queryString.parse(query, { arrayFormat: 'bracket-separator', arrayFormatSeparator: '|', parseNumbers: true, parseBooleans: true });
};


export const createURLPath = (params) => {
  const { path, queryObject, useFullPath = false } = params;

  let url = '';

  if (useFullPath) {
    url = `${window.location.protocol}//${window.location.host}`;
  }

  if (path) {
    url += path;
  }

  const query = queryString.stringify(queryObject, { arrayFormat: 'bracket-separator', arrayFormatSeparator: '|', skipNull: true, skipEmptyString: true });

  if (query) {
    url += `?${query}`;
  }

  return url;
};